import React, { createContext, useContext, useReducer } from "react";
import { initialSingleVesselStore } from "./initialStore";
import { singleVesselReducer } from "./singleVesselReducer";

const SingleVesselContext = createContext(null);

export function SingleVesselProvider({ children }) {
  const [state, dispatch] = useReducer(singleVesselReducer, initialSingleVesselStore);

  return (
    <SingleVesselContext.Provider value={{ state, dispatch }}>
      {children}
    </SingleVesselContext.Provider>
  );
}

export function useSingleVesselContext() {
  const context = useContext(SingleVesselContext);
  if (!context) {
    throw new Error("useSingleVesselContext must be used within a SingleVesselProvider");
  }
  return context;
}
